import React, { Component } from "react"
import { withTranslation } from 'react-i18next';
import { GlobalContext } from "../../context/GlobalContext";
import { resendActivationCode, validateEmailUpdate, validateContactUpdate } from "../../api/api";
import Modal from '../Modal';

class ActivationCode extends Component {
  static contextType = GlobalContext;
  constructor(props) {
    super(props);
    this.state = {
      profileMobileNumber: '',
      profileEmail: '',
      activationCode: '',
      hashCode: '',
      errors: {},
      screenToShow: '',
      openModalFlag: false,
      loading: false,
      otpType: '',
    }
  }

  componentDidMount = () => {
    const [context] = this.context;
    this.setState({
      profileMobileNumber: context.mobileNum,
      screenToShow: context.profileUpdateScreen,
      otpType: context.otpType,
      profileEmail: context.email,
      hashCode: context.hashCode
    })
  }

  handleOtpChange = (evt) => {
    const re = /^[0-9\b]+$/;
    if (evt.target.value === "" || re.test(evt.target.value)) {
      this.setState({
        activationCode: evt.target.value,
      });
    }
  };

  profileValidateForm() {
    let errors = {};
    let formIsValid = true;

    if (!this.state.activationCode) {
      formIsValid = false;
      errors["profileUpdate_pin_code"] = "pin_code_required";
    }
    this.setState({
      errors: errors,
    });

    return formIsValid;
  }

  handleOtpSubmit = async (e) => {
    e.preventDefault();

    if (this.profileValidateForm()) {
      const [context, dispatch] = this.context;
      const { profileMobileNumber, activationCode, otpType, hashCode } = this.state;
    
      if (otpType === "Mobile") {
        const validateContactUpdateResponse = await validateContactUpdate(hashCode, activationCode);

        if (validateContactUpdateResponse.data?.data?.code === "MAPI-000") {
          localStorage.setItem('contactNumber', profileMobileNumber);
          dispatch({
            type: 'UPDATE_STEP_VALUE',
            payload: {
              stepVal: "two"
            }
          })
          dispatch({
            type: 'GO_TO_SCREEN',
            payload: { profileUpdateScreen: "EmailAndCityUpdate" }
          })
        }
        else {
          this.setState({
            loading: false,
            openModalFlag: true
          });
        }
      }

      if (otpType === "Email") {
        const validateEmailUpdateResponse = await validateEmailUpdate(hashCode, activationCode);

        if (validateEmailUpdateResponse.data?.status?.code === "MAPI-000") {
          dispatch({
            type: 'UPDATE_STEP_VALUE',
            payload: {
              stepVal: "three"
            }
          })
          dispatch({
            type: 'GO_TO_SCREEN',
            payload: { profileUpdateScreen: "IDNumAndNationality" }
          })
        }
        else {
          let errors = {};
          errors["customError"] = "invalid_data";
          this.setState({
            errors: errors,
            loading: false,
            openModalFlag: true
          });
        }
      }
    }
  }

  handleResendCode = async (e) => {
    e.preventDefault();
    const { hashCode, otpType } = this.state;
    await resendActivationCode(hashCode, otpType);

    this.setState({
      openModalFlag: false,
    })
  }

  handleClose = () => {
    this.setState({
      openModalFlag: false,
    })
  }

  render() {
    const { t } = this.props;
    const { otpType, profileMobileNumber, profileEmail, openModalFlag, errors } = this.state
    return (
      <>
        {openModalFlag && <Modal openModalFlag={openModalFlag} handleSendNow={this.handleResendCode} handleClose={this.handleClose} />}

        {otpType === "Mobile" && <div className="pu_subheading">{t("verification_code_senttext") + " " + profileMobileNumber + "."}</div>}
        
        {otpType === "Email" && <div className="pu_subheading"> {t("verification_code_mail") + " " + profileEmail + "."}</div>}

        <div className={"form-group " + (errors.profileUpdate_pin_code ? "not-valid" : "")}>
          <input
            type="text"
            className="form-control pu-activation-code"
            placeholder={t("profileUpdate_pin_code")}
            pattern="[0-9]*"
            maxLength="4"
            value={this.state.activationCode}
            onChange={this.handleOtpChange}
          />

          {errors.profileUpdate_pin_code ? (
            <div className="alert alert-danger" role="alert">
              {t(errors.profileUpdate_pin_code)}{" "}
              <i
                className="fa fa-exclamation-circle"
                aria-hidden="true"
              ></i>
            </div>
          ) : (
            <div className="empty-alert">&nbsp;</div>
          )}
        </div>

        <div className="popup2_open login-resendCode-btn" onClick={(e) => this.handleResendCode(e)}> {t("resendTheCode")} </div>
        <button
          onClick={this.handleOtpSubmit}
          type="submit mu"
          name="confirm_button"
          className="btn min_outlin_btn active">
          {t("verify_code")}{" "}
          <i className="fa fa-arrow-right" aria-hidden="true"></i>
        </button>
      </>
    )
  }
}

export default withTranslation()(ActivationCode);